"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/web.dom-collections.iterator.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "validations", {
  enumerable: true,
  get: function get() {
    return _validations["default"];
  }
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

require("core-js/modules/es.array.reduce.js");

require("core-js/modules/es.object.values.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/web.timers.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _reactMedia = _interopRequireDefault(require("react-media"));

var _utils = require("../utils");

var _mobile = _interopRequireDefault(require("./mobile"));

var _desktop = _interopRequireDefault(require("./desktop"));

var _validations = _interopRequireDefault(require("./validations"));

var _excluded = ["onChange", "name"],
    _excluded2 = ["input", "questions", "mobile"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var calculateSum = function calculateSum(values) {
  return Object.values(values).reduce(function (acc, v) {
    return acc + v;
  }, 0);
};

var GAD7 = function GAD7(_ref) {
  var _ref$input = _ref.input,
      _onChange = _ref$input.onChange,
      name = _ref$input.name,
      restInput = (0, _objectWithoutProperties2["default"])(_ref$input, _excluded),
      questions = _ref.questions,
      mobile = _ref.mobile,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded2);

  var _useState = (0, _react.useState)({}),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      values = _useState2[0],
      setValues = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      questionIndex = _useState4[0],
      setQuestionIndex = _useState4[1];

  var getQuestionKey = function getQuestionKey(index) {
    return "".concat(name, "_").concat(index);
  };

  return /*#__PURE__*/_react["default"].createElement(_reactMedia["default"], {
    queries: _utils.ReactMediaQueries
  }, function (matches) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (matches.mobile || mobile) && /*#__PURE__*/_react["default"].createElement(_mobile["default"], (0, _extends2["default"])({}, props, restInput, {
      name: name,
      value: values[getQuestionKey(questionIndex)],
      key: questionIndex,
      question: questions[questionIndex],
      progress: (questionIndex + 1) / questions.length * 100,
      onChange: function onChange(d) {
        var newValues = _objectSpread(_objectSpread({}, _lodash["default"].omit(values, name)), {}, (0, _defineProperty2["default"])({}, getQuestionKey(questionIndex), d));

        var valuesWithSum = _objectSpread(_objectSpread({}, newValues), {}, (0, _defineProperty2["default"])({}, name, calculateSum(newValues)));

        setValues(valuesWithSum);

        _onChange(valuesWithSum);

        setTimeout(function () {
          if (questionIndex < questions.length - 1) setQuestionIndex(questionIndex + 1);
        }, 200);
      },
      onBack: function onBack() {
        return setQuestionIndex(questionIndex - 1);
      },
      disableBack: _lodash["default"].isEqual(questionIndex, 0)
    })), matches.desktop && !mobile && /*#__PURE__*/_react["default"].createElement(_desktop["default"], (0, _extends2["default"])({}, props, restInput, {
      questions: questions,
      values: values,
      inter: name,
      getQuestionKey: getQuestionKey,
      onChange: function onChange(d) {
        var newValues = _objectSpread(_objectSpread({}, values), d);

        var valuesWithSum = _objectSpread(_objectSpread({}, newValues), {}, (0, _defineProperty2["default"])({}, name, calculateSum(_lodash["default"].omit(newValues, name))));

        setValues(valuesWithSum);

        _onChange(valuesWithSum);
      }
    })));
  });
};

GAD7.defaultProps = {
  question_label: /*#__PURE__*/_react["default"].createElement("p", null, "Over the ", /*#__PURE__*/_react["default"].createElement("b", null, "last 2 weeks"), ", how often have you been bothered by the following problems?"),
  questions: ['Feeling nervous, anxious, or on edge', 'Not being able to stop or control worrying', 'Worrying too much about different things', 'Trouble relaxing', 'Being so restless that it is hard to sit still', 'Becoming easily annoyed or irritable', 'Feeling afraid as if something awful might happen'],
  answer_labels: ['Not at all', 'Several days', 'More than half the days', 'Nearly every day'],
  input: {},
  mobile: false,
  hideFirstColumn: false
};
GAD7.propTypes = {
  input: _propTypes["default"].shape({
    onChange: _propTypes["default"].func.isRequired,
    onBlur: _propTypes["default"].func,
    onFocus: _propTypes["default"].func
  }),
  hideFirstColumn: _propTypes["default"].bool
};
var _default = GAD7;
exports["default"] = _default;